import React from 'react';
import { styled } from '@linaria/react';
import { FacilityIcon } from 'components/Accommodation/Facilities/FacilityIcon';
import { Hotel } from 'modules/sapiSearch/slice';
import { LovHit } from 'modules/search/slice';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Icon, iconsList } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w19hpgsv",
  propsAsIs: false
});
const _exp3 = /*#__PURE__*/() => Flex.Row;
const VrItem = /*#__PURE__*/styled(_exp3())({
  name: "VrItem",
  class: "v1l1u39w",
  propsAsIs: true
});
const properties: Record<string, keyof typeof iconsList> = {
  bathrooms: 'Bath',
  bedrooms: 'DoubleBed'
} as const;
const messages = {
  bathrooms: {
    id: 'bathroom',
    defaultMessage: '{value} {value, plural, one {bathroom} other {bathrooms}}'
  },
  bedrooms: {
    id: 'bedroom',
    defaultMessage: '{value} {value, plural, one {bedroom} other {bedrooms}}'
  }
};

// Being used to sort the `vrDetails` list based on the `reference` array
const reference = ['bedrooms', 'bathrooms'];
const MAX_LIST_LENGTH = 6;
interface Props {
  vrDetails?: Hotel['vrDetails'];
  rankedFacilities?: LovHit[];
  className?: string;
  showVrDetails: boolean;
}
export const VacationRentalDetails = ({
  vrDetails = {},
  rankedFacilities = [],
  className = '',
  showVrDetails
}: Props) => {
  const vrDetailsArr = Object.keys(vrDetails);
  if (showVrDetails && vrDetailsArr.length === 0) return null;
  const rankedFacilitiesMaxLength = showVrDetails ? Math.max(MAX_LIST_LENGTH - vrDetailsArr.length, 0) : MAX_LIST_LENGTH;
  return <div className={className} data-id="VacationRentalDetails">
      <Wrapper>
        {showVrDetails && vrDetailsArr.sort((a, b) => reference.indexOf(a) - reference.indexOf(b)).map((key, index) => {
        if (vrDetails[key].count) {
          return <VrItem alignItems="flex-start" gap="s200" key={index}>
                    <Icon size="sm" name={properties[key]} colorPath={'content.neutral.c950'} />
                    <Text variant={'bodyXS'} colorPath={'content.neutral.c950'}>
                      <FormattedMessageWrapper {...messages[key]} values={{
                value: vrDetails[key].count
              }} />
                    </Text>
                  </VrItem>;
        }
      })}
        {rankedFacilities.slice(0, rankedFacilitiesMaxLength).map(facility => <VrItem alignItems="flex-start" gap="s200" key={facility.id}>
            <FacilityIcon size="sm" facility={facility} colorPath={'content.neutral.c950'} />
            <Text variant={'bodyXS'} colorPath={'content.neutral.c950'}>
              {facility.value}
            </Text>
          </VrItem>)}
      </Wrapper>
    </div>;
};

require("./VacationRentalDetails.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./VacationRentalDetails.tsx");